import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { groupBy, map, mergeMap, of, reduce, toArray } from 'rxjs';
import { EventService } from 'src/app/services/event.service';

/**
 * The Options used for sorting
 */
interface SortOption {
  /**
   * The Value of the Filteroption
   */
  value: string;
  /**
   * The viewValue (visible to the User) of the Filteroption
   */
  viewValue: string;
  /**
   * Is the  Filteroption disabled
   */
  state: boolean;
}
/**
 * The Object used to load GoogleCharts
 */
declare var google: any;

@Component({
  selector: 'report-calendar-data',
  templateUrl: './calendar-data.component.html',
  styleUrls: ['./calendar-data.component.scss']
})

export class CalendarDataComponent implements OnInit {
  /**
   * The Events that are selectable
   */
  @Input() events: SortOption[] = [];
  /**
   * The Form to selct the Vent
   */
  calenderFilterForm: UntypedFormGroup;
  /**
   * Has the Chart been loaded
   */
  finishedLoadingCalendeData: boolean = false;
  /**
   * isCalenderChartEmpty => no Reservations
   */
  isCalenderChartEmpty: boolean = true;
  /**
   * The Data of the Linechart
   */
  data_reservations_line = [];
  /**
   * constructor
   * Init the Form
   * @param fb 
   * @param eventService 
   */
  constructor(
    private fb: UntypedFormBuilder,
    private eventService: EventService,) {
    this.calenderFilterForm = this.fb.group({
      event: ["", []],
    })
  }
  /**
   * ngOnInit
   * Set Value for Select-Dropdown
   */
  ngOnInit() {
    this.eventService.getTopThreeEvents(['ACTIVE', 'HIDDEN'], null, null, null).subscribe(val => {
      this.calenderFilterForm.patchValue({
        event: val[0].publicId
      })
      this.drawCalenderChart();
    })
  }
  /**
   * Change the current Event the data is loaded from => Redraw the Chart
   * @param e 
   */
  changeEventForCalenderChart(e) {
    this.drawCalenderChart();
  }
  /***
   * Draw the Calendar Chart
   */
  drawCalenderChart() {
    this.finishedLoadingCalendeData = false;
    document.getElementById('calendar_basic').style.display = 'block';
    this.isCalenderChartEmpty = false;
    google.charts.load('current', {
      'packages': ["calendar, corechart"], 'language': 'de', callback: () => {
        var dataTable = new google.visualization.DataTable();
        dataTable.addColumn({ type: 'date', id: 'Date' });
        dataTable.addColumn({ type: 'number', id: 'Reservations' });
        this.eventService.getReservationListForEventGrouped(this.calenderFilterForm.value.event).subscribe((val: Array<any>) => {
          val.forEach(element => {
            this.data_reservations_line.push({
              "group": "Reservierungen",
              "key": new Date(element.day).toLocaleDateString("de-De", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              }),
              "value": element.reservationCount.toLocaleString('de-DE')
            })
          });
          this.data_reservations_line = [...this.data_reservations_line];

          //Push Grouped Dates to DataArray
          if (val.length >= 1) {
            val.forEach(element => {
              dataTable.addRows([
                [new Date(element.day), element.reservationCount],
              ]);
            });
            //Group by Year for Height of Chart
            of(...val).pipe(
              groupBy((p: any) => new Date(p.day).toLocaleDateString().split('.')[2]),
              mergeMap(group$ => {
                return group$.pipe(reduce((acc, cur) => [...acc, cur], [`${group$.key}`]))
              }
              ),
              map(arr => {
                return ({ date: arr[0], reservations: arr.slice(1) })
              }),
              toArray()
            ).subscribe(value => {
              ///Draw Chart
              var chart = new google.visualization.Calendar(document.getElementById('calendar_basic'));
              var options = {
                title: "",
                tooltip: { isHtml: true },
                calendar: {
                  cellSize: this.scaleCell(5, 20),
                  daysOfWeek: 'MDMDFSS',

                },
                //Calc Height of Chart based on the Grouped Years
                height: 300 * value.length
              }
              chart.draw(dataTable, options);
              //Set Spinnter to invisible
              this.finishedLoadingCalendeData = true;
              this.isCalenderChartEmpty = false;
            })
          } else {
            document.getElementById('calendar_basic').style.display = 'none';
            this.finishedLoadingCalendeData = true;
            this.isCalenderChartEmpty = true;
          }
        });
      }
    });
  }
  /**
   * Scale the Cell of the Chart
   * @param min 
   * @param max 
   * @returns 
   */
  scaleCell(min, max) {
    var cellSize = window.innerWidth / 60;
    if (cellSize > max) return max;
    if (cellSize < min) return min;
    return cellSize;
  }

}
